// extracted by mini-css-extract-plugin
module.exports = {"notification-link":"styles_notification-link__qPgVP","slideIn":"styles_slideIn__rvyBI","hide":"styles_hide__9dnxk","red":"styles_red__ySXrW","dismiss":"styles_dismiss__2dqjT"};